import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateVenueContact($companyId: ID!, $id: ID!, $attributes: VenueContactAttributes!) {
    updateVenueContact(companyId: $companyId, id: $id, attributes: $attributes) {
      venueContact {
        id
        ...UpdatedVenueContact
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedVenueContact on VenueContact {
    id
    name
    email
    phone
    color
    contactType
    user { id displayName email }
    venue { id }
  }
`
